<script>
    import { t } from '../i18n.js'
    import ViewCardContainer from '../components/ViewCardContainer.svelte'
    import { onMount } from 'svelte'

    onMount(() => {
		window.scrollTo(0,0)
	})

</script>

<ViewCardContainer pageTitle={$t('terms.page-title')}>
    <p class="mb-4 whitespace-pre-line">{@html $t('terms.general')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.service-info')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.rights-and-forbidden')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.reference-rules')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.open-data')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.limitations-of-liability')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.user-loads')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.data-protection')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.ui-technical-trademarks-logos')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.payments')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.terms-changes')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.service-changes')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.law-resolution')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.service-provider-notifications')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.contact-information')}</p>
</ViewCardContainer>